import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ImageComponent from '../ImageComponent/ImageComponent';
import styles from './EntryPageTemplate.module.scss';

const backgroundImageUrl = '/branding/RI-Logo-with-text.png';
function EntryPageTemplate(props) {
    const { applicationName, applicationLogo, contentToRender } = props;        
    console.log(`applicationName = ${applicationName}`);
    // FB 21902 -----
    const currentURL = window.location.href;

    // State to store the background image URL
    const [backgroundImage, setBackgroundImage] = useState(`url(${backgroundImageUrl})`);
    useEffect(() => {
        currentURL.includes('localhost') ? 
        setBackgroundImage(`url(${backgroundImageUrl})`) : 
        setBackgroundImage(`url(/account-management/${backgroundImageUrl})`); 
    }, []); // Empty dependency array ensures this runs only once, on load

    return (
        <div id="entryPageTemplate" className={styles.entryPageTemplate} > 
            <div id="entryPageTemplateHeader" className={styles.entryPageTemplateHeader} style={{ backgroundImage: backgroundImage }}>
                <div id="entryPageTemplateLogo" className={styles.entryPageTemplateLogo}>
                    <ImageComponent src={applicationLogo} title={applicationName} />
                </div>
                <h2
                    id="entryPageTemplateApplicationName"
                    className={styles.entryPageTemplateApplicationName}
                >
                    {applicationName}
                </h2>
            </div>
            <div id="entryPageTemplateContent" className={styles.entryPageTemplateContent}>
                <div
                    id="entryPageContentContainer"
                    className={styles.entryPageContentContainer}
                >
                    {contentToRender}
                </div>
            </div>
        </div>
    );
}

EntryPageTemplate.propTypes = {
    applicationName: PropTypes.string.isRequired,
    applicationLogo: PropTypes.string.isRequired,
    contentToRender: PropTypes.shape({}).isRequired
};

export default EntryPageTemplate;
